import HealthScoreQuestionnaire from "@/features/HealthScore/components/HealthScoreQuestionnaire";
import {
  Question,
  QuestionnaireAnswer,
  QuestionType,
  QuestionnaireType,
  IntenseExerciseMinutes,
  SleepHours,
  FruitVegServings,
  AlcoholConsumption,
  SmokerStatus,
} from "@/features/HealthScore/components/HealthScoreQuestionnaire/types";
import { useTranslation } from "react-i18next";

export default function LifeStyleQuestionnaire() {
  const { t } = useTranslation();

  const LIFESTYLE_QUESTIONS: Question[] = [
    {
      type: QuestionType.INTENSE_EXERCISE,
      meta: {
        values: [
          IntenseExerciseMinutes.ZERO_TO_150,
          IntenseExerciseMinutes.ONE_FIFTY_TO_300,
          IntenseExerciseMinutes.THREE_HUNDRED_PLUS,
        ],
      },
    },
    {
      type: QuestionType.SLEEP,
      meta: {
        values: [
          SleepHours.LESS_THAN_7,
          SleepHours.SEVEN_TO_9,
          SleepHours.MORE_THAN_9,
        ],
      },
    },
    {
      type: QuestionType.FRUIT_VEG_CONSUMPTION,
      meta: {
        values: [
          FruitVegServings.ONE,
          FruitVegServings.TWO,
          FruitVegServings.THREE,
        ],
      },
    },
    {
      type: QuestionType.ALCOHOL_CONSUMPTION,
      meta: {
        values: [
          AlcoholConsumption.NONE,
          AlcoholConsumption.ONE,
          AlcoholConsumption.TWO,
          AlcoholConsumption.TWO_PLUS,
        ],
      },
    },
    {
      type: QuestionType.SMOKER_STATUS,
      meta: {
        values: [
          SmokerStatus.NEVER,
          SmokerStatus.STOPPED,
          SmokerStatus.REGULAR,
        ],
      },
    },
  ];

  const handleSubmit = async (answers: QuestionnaireAnswer[]) => {
    const payload = {
      questionnaireType: QuestionnaireType.LIFESTYLE,
      value: answers,
    };
    // TODO: Replace with actual API call
    console.log("Submitting lifestyle answers:", payload);
  };

  return (
    <HealthScoreQuestionnaire
      questions={LIFESTYLE_QUESTIONS}
      translationPrefix="Lifestyle.questionnaire"
      onSubmit={handleSubmit}
      title={t("Lifestyle.questionnaire.title")}
    />
  );
}
